import {DataSource} from "typeorm";
import {createDataSource} from "@/modules/database/services/db";
import {GameSlot} from "@/modules/main-menu/entity";
import {Achievement} from "@/modules/archiements/entity";

export let db: DataSource;

export async function initDataSource(): Promise<DataSource> {
  return db ??= await createDataSource('main-menu', [
    GameSlot,
    Achievement,
  ]);
}